import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';

@Injectable()
export class GastosService {

  private service_url;
  constructor(private constantsService: ConstantsService, private http: Http, private authService: AutenticacionService, private validatorService: ValidatorService, private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/gastos';
  }

  public validate(data){
    console.log("validating... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["idSucursales"])){
      error["idSucursales"] = this.errorService.required;
    }
    
    if(!this.validatorService.required(data["idSubcategoriasGastos"])){
        error["idSubcategoriasGastos"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["descripcion"])){
      error["descripcion"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["descripcion"], 500)){
      error["descripcion"] = this.errorService.max(500);
    }

    if(!this.validatorService.required(data["monto"])){
      error["monto"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["forma"])){
        error["forma"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["fecha"])){
        error["fecha"] = this.errorService.required;
    }

    
    return error;
  }

  public validateUpdate(data){
    console.log("validating... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["descripcion"])){
      error["descripcion"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["descripcion"], 500)){
      error["descripcion"] = this.errorService.max(500);
    }

    if(!this.validatorService.required(data["monto"])){
      error["monto"] = this.errorService.required;
    }
    return error;

  }
  getDefaultSchedule() {
    return {
      'id': '',
      'idSucursales': '',
      'idSubcategoriasGastos': '',
      'descripcion': '',
      'monto': '',
      'forma': '',
      'fecha': ''
    };
  }

  get(filters) {
    let queryParams = [];
    Object.keys(filters).forEach(key => {
      queryParams.push(key+"="+filters[key]);
    });
    return this.http.get(this.service_url + "?" +queryParams.join("&") , this.authService.getAuthHeaders());

  }

  getMetrics(filters) {
    let queryParams = [];
    Object.keys(filters).forEach(key => {
      queryParams.push(key+"="+filters[key]);
    });
    return this.http.get(this.service_url + "/metricas?" + queryParams.join("&"), this.authService.getAuthHeaders());
  }

  getDetalleGastosMes(filters) {
    let queryParams = [];
    Object.keys(filters).forEach(key => {
      queryParams.push(key+"="+filters[key]);
    });
    return this.http.get(this.service_url + "/detalle-gastos-mes?" + queryParams.join("&"), this.authService.getAuthHeaders());
  }

  getGastosMes(filters) {   
    let queryParams = [];
    Object.keys(filters).forEach(key => {
      queryParams.push(key+"="+filters[key]);
    });
    console.log("Servicio: ",this.service_url + "/metricas/mes?" + queryParams.join("&"))
    return this.http.get(this.service_url + "/metricas/mes?" + queryParams.join("&"), this.authService.getAuthHeaders());
  }

  getGastosGraficaDona(filters) {   
    let queryParams = [];
    Object.keys(filters).forEach(key => {
      queryParams.push(key+"="+filters[key]);
    });
    return this.http.get(this.service_url + "/metricas/mes/seleccionado?" + queryParams.join("&"), this.authService.getAuthHeaders());
  }
  
  getMetricsByCategory(filters) {
    let queryParams = [];
    Object.keys(filters).forEach(key => {
      queryParams.push(key+"="+filters[key]);
    });
    return this.http.get(this.service_url + "/metricas/categoria?" + queryParams.join("&"), this.authService.getAuthHeaders());
  }
  
  getGastosByCategory(filters) {
    let queryParams = [];
    Object.keys(filters).forEach(key => {
      queryParams.push(key+"="+filters[key]);
    });
    return this.http.get(this.service_url + "/detalle-gastos-categoria?" + queryParams.join("&"), this.authService.getAuthHeaders());
  }

  getGastoById(id) {
    console.log("IdGasto_GET:" ,id);
    return this.http.get(this.service_url + '/detalle-gastos-mes/'+id, this.authService.getAuthHeaders());
  }

  find(id : number){
    return this.http.get(this.service_url + '/' + id, this.authService.getAuthHeaders());
  }
  // buscar objeto simple
  search(search, page = null) {
    // buscar con paginacion
    if (page)
      return this.http.get(this.service_url + "?paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.service_url + "?paginate=true&search=" + search, this.authService.getAuthHeaders());
  }

  create(data) {
    return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  update(data, id) {
    return this.http.put(this.service_url + '/detalle-gastos-mes/update/' + id, data, this.authService.getAuthHeaders());
  }

  delete(id) {
    console.log("IDGasto:" ,id);
    return this.http.delete(this.service_url + '/detalle-gastos-mes/'+id, this.authService.getAuthHeaders());
  }

  
  public writePermission() {
    return true;
    //return this.authService.hasPermission(10, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/gastos.service.ts